import BaseService from "./BaseService.js";

class KycService extends BaseService {
    getReport() {
        return this.apiGet({
            url: '/kyc'
        })
    }
    saveReport(payload) {
        return this.apiPost({
            url: "/kyc",
            data: payload,
        });
    }
}

export default new KycService();
